// Id,title,levels
module.exports = [
  {id: 1, title: "I don't know / I just need a qualification", levels: [1, 2, 3, 6]},
  {id: 3, title: 'Communication Support Worker (school and/or college)', levels: [3]},
  {id: 4, title: 'Teacher for the Deaf', levels: [2, 3, 6]},
  {id: 5, title: 'Learning Support Assistant', levels: [2, 3]},
  {id: 6, title: 'Speech and Language Therapist', levels: [2, 3, 6]},
  {id: 7, title: 'Counsellor', levels: [3, 6]},
  {id: 8, title: 'Charity Worker for Deaf People', levels: [3, 6]},
  {id: 9, title: 'Community Support Worker', levels: [3, 6]},
  {id: 10, title: 'Audiology Scientist/Department of Audiology', levels: [2, 3]},
  {id: 11, title: 'Advocates', levels: [2, 3, 6]},
  {id: 12, title: 'Youth Worker for the Deaf', levels: [3, 6]},
  {id: 13, title: 'Social Worker for the Deaf', levels: [3, 6]},
  {id: 14, title: 'BSL/English Interpreter', levels: [6]},
  {id: 15, title: 'BSL/English Translator', levels: [6]},
  {id: 16, title: 'In-vision TV signer', levels: [6]},
  {id: 17, title: 'Civil/public services (receptionist, NHS/education staff, police, ambulance, etc)', levels: [2, 3, 6]},
  {id: 18, title: 'Communication Support Worker (university or Deaf organisation)', levels: [6]}
];



// WEBPACK FOOTER //
// ./src/components/CoursePicker/professions.js